import Page from 'shared/types/Page'

const setMenuPages = (pages: Page[]) => ({
    type: 'SET_MENU_PAGES',
    pages
})

export default setMenuPages